import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function PerformanceTrendCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.vendPerformanceTrendChart !== 'undefined') {
      window.vendPerformanceTrendChart.canvas = chartRef.current;
      window.vendPerformanceTrendChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Performance Trend</h3>
        <span className="click-tag">Click points for monthly detail</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="vendPerformanceTrend" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
